module.exports = {"id":"blues","name":"Blues","isInbuilt":true,"theme":{"type":"dark","palette":{"primaryColor":{"id":"indigo","shadeIndex":4},"secondaryColor":{"id":"lime","shadeIndex":4},"backgroundColor":{"id":"indigo","shadeIndex":9},"custom":{"today":"#1455c0","soon":"#FF9300","overdue":"#F00","later":"#22B30B","unreadItem":"#1455c0","highPriority":"orange"}},"hideTaskEditIcon":false,"isDense":false,"typography":{"useNextVariants":true}}}


//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-themes/Blues.json
// module id = 706
// module chunks = 0